import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/live-streaming"
    exact
    path="/business/products/live-streaming"
    component={AsyncPage}
  />,
];
